"use client";
import React, { useState } from "react";
import { BookingSection } from "./BookingSection";

export const HairDressersSection: React.FC = () => {
    const [selectedItem, setSelectedItem] = useState<number>(-1);
    
    const handleScroll = (id: string) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: 'start',
            });
        }
    };

  return (
    <>
        {selectedItem === -1 && <section id="team-sections" className="services-section ftco-section">
            <div className="container team-area pb-180">
                <div className="container2">
                    <div className="row justify-content-center pb-3">
                        <div className="col-md-7 heading-section text-center">
                            <span className="subheading">Zakazivanje</span>
                            <h2 className="mb-4" style={{ color: 'black' }}>zakažite svoj termin</h2>
                            <p style={{ fontSize: '20px' }}>
                                Osigurajte svoj termin brzo i jednostavno! Prepustite se profesionalnoj nezi naših frizera i budite sigurni da će vaš stil biti u najboljim rukama.
                            </p>
                        </div>
                    </div> 
                    <div className="row team-active dot-style">
                        <div className="wrapper col-xl-4 col-lg-4 col-md-6 col-sm-">
                            <div className="single-team2 text-center" onClick={() => { 
                                    setSelectedItem(1); handleScroll("team-sections");
                                    setTimeout(() => handleScroll("team-sections"), 50); 
                                }}>
                                <div className="team-img2">
                                    <img src="/images/bobana.jpg" alt="" />
                                </div>
                                <div className="team-caption2">
                                    <span>Senior stilista</span>
                                    <h3>Bobana Radovanović</h3>
                                </div>
                            </div>
                        </div>
                        <div className="wrapper col-xl-4 col-lg-4 col-md-6 col-sm-">
                            <div className="single-team2 text-center" onClick={() => { 
                                    setSelectedItem(2); handleScroll("team-sections");
                                    setTimeout(() => handleScroll("team-sections"), 50); 
                                }}>
                                <div className="team-img2">
                                    <img src="/images/ognjen.jpeg" alt="" />
                                </div>
                                <div className="team-caption2">
                                    <span>Junior stilista</span>
                                    <h3>Ognjen Vujinović</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>}

        {selectedItem > 0 && <BookingSection setSelectedItem={setSelectedItem} selectedItem={selectedItem} />}
    </>     
  );
};
